(ns app.http

  (:require [lambdaisland.fetch :as fetch]
            [goog.object :as gobj]))


(defn post
  [url options]
  (-> (fetch/post url
               (merge options {:headers  {"authorization" "Bearer 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"}
                               :accept :json
                               :content-type :json}))
      (.then (fn [resp]
               (js->clj (:body resp) :keywordize-keys true)))))



#_(-> (fetch/post "https://api.sendgrid.com/v3/validations/email"
                  {:body {"email" "dsfdsfdsfdsafs@gmail.com"
                          "source" "signup"}
                   :headers {"authorization" "Bearer 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"}
                   :accept :json
                   :content-type :json})
      (.then (fn [resp]
               (def resp resp)
               (-> resp

                   :body
                 ;; the actual response is a js object, not a clojure map
                   (gobj/get "result"))))
      (.then (fn [data]
               (js/console.log "AA: " (gobj/get data "score")))))

#_(:result (js->clj (:body resp) :keywordize-keys true))